import { publicApiHeaders } from './publicApiAuth';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE_URL}/user/auth/${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...publicApiHeaders,
      ...(options.headers || {}),
    },
    ...options,
  });

  const data = await response.json().catch(() => ({}));

  if (path === 'session' && response.status === 401) {
    window.dispatchEvent(new Event('cd:user-session-invalid'));
  }

  if (!response.ok || data.status === false) {
    throw new Error(data.message || data.success || 'Authentication request failed.');
  }

  return data;
}

export const requestUserLoginOtp = (mobile) => request('login/request-otp', {
  method: 'POST',
  body: JSON.stringify({ mobile }),
});

export const verifyUserLoginOtp = (mobile, otp) => request('login/verify-otp', {
  method: 'POST',
  body: JSON.stringify({ mobile, otp }),
});

export const getUserProfile = () => request('me', {
  headers: {
    Authorization: `Bearer ${localStorage.getItem('cd_user_token') || ''}`,
  },
});

export const checkUserSession = () => request('session', {
  headers: {
    Authorization: `Bearer ${localStorage.getItem('cd_user_token') || ''}`,
  },
});

export const redirectToGoogleLogin = () => {
  window.location.assign(`${API_BASE_URL}/user/auth/google/login`);
};

export const requestUserRegistrationOtp = (mobile) => request('register/request-otp', {
  method: 'POST',
  body: JSON.stringify({ mobile }),
});

export const registerUser = (payload) => request('register', {
  method: 'POST',
  body: JSON.stringify(payload),
});

export const logoutUser = () => request('logout', {
  method: 'POST',
});

export const updateUserProfile = (payload) => request('profile', {
  method: 'POST',
  headers: {
    Authorization: `Bearer ${localStorage.getItem('cd_user_token') || ''}`,
  },
  body: JSON.stringify(payload),
});

export const changeUserPassword = (payload) => request('change-password', {
  method: 'POST',
  headers: {
    Authorization: `Bearer ${localStorage.getItem('cd_user_token') || ''}`,
  },
  body: JSON.stringify(payload),
});
